import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, Link } from "react-router-dom";
import api from "../../api/projects";
import { useForm } from "react-hook-form";
import Nav from "../header/Nav.component";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { Modal } from "react-bootstrap";

import down2 from "../../assets/images/down2-80.png";
import down1 from "../../assets/images/down1-90.png";
import txt_icon from "../../assets/images/txt-52.png";

import "./Analysis.css";
// import history from '../../history';
const user = "6054074f8c41cc4cba4333ef";

const Analysis = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [showAlignmentModal, setShowAlignmentModal] = useState(false);

  const handleCloseAlignmentModal = () => {
    setShowAlignmentModal(false)
  };

  return (
    <>
      <Nav active={4} />
      <div className="section-2 wf-section">
        {/* <div className="div-block-2">
          <div className="div-block-3">Overview</div>
          <div className="div-block-3 active">Project Summery</div>
          <div className="div-block-3">Files</div>
        </div> */}
        <div className="div-analysis-desc">
          <div className="text-block-9">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed
            elementum scelerisque pretium. Praesent et lacus id leo varius
            auctor non et libero.
            <br />
          </div>
        </div>
        <div className="div-analysis-nav">
          <div className="div-block-24">
            <div className="text-block-4">Test Analysis 1</div>
          </div>
          <div />
          <div className="div-block-15">
            <div className="nav-dropdown">
              <div>Current Workflow</div>
              <img
                src="https://uploads-ssl.webflow.com/60faa77e21b22054e04713b8/60fc2f152b2dc0e3c9a69611_icons8-chevron-down-90.png"
                loading="lazy"
                width={18}
                alt=""
              />
            </div>
            <div className="nav-dropdown">
              <div>VM Speed</div>
              <img
                src="https://uploads-ssl.webflow.com/60faa77e21b22054e04713b8/60fc2f152b2dc0e3c9a69611_icons8-chevron-down-90.png"
                loading="lazy"
                width={18}
                alt=""
              />
            </div>
          </div>
          <div className="analysis-start-btn">Start Analysis</div>
        </div>
        <div className="div-main">
          <div className="input-section">
            <div className="text-block">Inputs</div>
            <div className="io-card">
              <div className="io-icon-wrapper">
                <img
                  src="https://uploads-ssl.webflow.com/60faa77e21b22054e04713b8/60fc2b77d806aaf245f3736d_icons8-txt-52.png"
                  loading="lazy"
                  width={23}
                  alt=""
                />
              </div>
              <div className="io-files-wrapper">
                <div className="io-files-text">*.fq.gz *fastq.gz *.sam</div>
              </div>
              <div className="io-type">
                <div className="text-block-6">Reads</div>
              </div>
            </div>
            <div className="io-card">
              <div className="io-icon-wrapper">
                <img
                  src="https://uploads-ssl.webflow.com/60faa77e21b22054e04713b8/60fc2b77d806aaf245f3736d_icons8-txt-52.png"
                  loading="lazy"
                  width={23}
                  alt=""
                />
              </div>
              <div className="io-files-wrapper">
                <div className="io-files-text">*.fq.gz *fastq.gz *.sam</div>
              </div>
              <div className="io-type">
                <div className="text-block-6">Reads</div>
              </div>
            </div>
            <div className="io-card">
              <div className="io-icon-wrapper">
                <img
                  src="https://uploads-ssl.webflow.com/60faa77e21b22054e04713b8/60fc2b77d806aaf245f3736d_icons8-txt-52.png"
                  loading="lazy"
                  width={23}
                  alt=""
                />
              </div>
              <div className="io-files-wrapper">
                <div className="io-files-text">*.factq_contaminants.txt</div>
              </div>
              <div className="io-type _2">
                <div className="text-block-6 _2">Custom Limits</div>
              </div>
            </div>
            <div className="io-card">
              <div className="io-icon-wrapper">
                <img
                  src="https://uploads-ssl.webflow.com/60faa77e21b22054e04713b8/60fc2b77d806aaf245f3736d_icons8-txt-52.png"
                  loading="lazy"
                  width={23}
                  alt=""
                />
              </div>
              <div className="io-files-wrapper">
                <div className="io-files-text">*.factq_contaminants.txt</div>
              </div>
              <div className="io-type _2">
                <div className="text-block-6 _2">Contaminants</div>
              </div>
            </div>
            <div className="io-card">
              <div className="io-icon-wrapper">
                <img
                  src="https://uploads-ssl.webflow.com/60faa77e21b22054e04713b8/60fc2b77d806aaf245f3736d_icons8-txt-52.png"
                  loading="lazy"
                  width={23}
                  alt=""
                />
              </div>
              <div className="io-files-wrapper">
                <div className="io-files-text">*.factq_adapters.txt</div>
              </div>
              <div className="io-type _3">
                <div className="text-block-6 _3">Adapters</div>
              </div>
            </div>
          </div>
          <div className="steps-section">
            <div className="div-step-1">
              <img
                src="https://uploads-ssl.webflow.com/60faa77e21b22054e04713b8/60fc361de96726018acfff6b_icons8-double-down-80.png"
                loading="lazy"
                width={24}
                alt=""
                className="image-2"
              />
              <div className="text-block">Analysis Strategy</div>
              <div className="btn-1 type-2" 
                  onClick={() => setShowAlignmentModal(true)}
                  >
                <div
                  className="btn-1-text"
                >
                  Alignment - Star
                </div>
              </div>
            </div>
            <div className="div-step-3">
              <div className="text-block-10">
                This is some text inside of a div block.
              </div>
              <div className="btn-1 type-2">
                <div className="btn-1-text">Count</div>
              </div>
              <img
                src="https://uploads-ssl.webflow.com/60faa77e21b22054e04713b8/60fc361de96726018acfff6b_icons8-double-down-80.png"
                loading="lazy"
                width={24}
                alt=""
                className="image-2"
              />
            </div>
            <div className="div-step-4">
              <div className="text-block-10">
                This is some text inside of a div block.
              </div>
              <div className="btn-1 type-2">
                <div className="btn-1-text">Differential Expression</div>
              </div>
            </div>
          </div>
          <div className="output-section">
            <div className="text-block">Output</div>
            <div className="io-card">
              <div className="io-icon-wrapper">
                <img
                  src="https://uploads-ssl.webflow.com/60faa77e21b22054e04713b8/60fc2b77d806aaf245f3736d_icons8-txt-52.png"
                  loading="lazy"
                  width={23}
                  alt=""
                />
              </div>
              <div className="io-files-wrapper">
                <div className="io-files-text">.stats-fastqc.html</div>
              </div>
              <div className="io-type">
                <div className="text-block-6">FastQC Report</div>
              </div>
            </div>
            <div className="io-card">
              <div className="io-icon-wrapper">
                <img
                  src="https://uploads-ssl.webflow.com/60faa77e21b22054e04713b8/60fc2b77d806aaf245f3736d_icons8-txt-52.png"
                  loading="lazy"
                  width={23}
                  alt=""
                />
              </div>
              <div className="io-files-wrapper">
                <div className="io-files-text">*.stats-fastqc.txt</div>
              </div>
              <div className="io-type">
                <div className="text-block-6">FastQC Stats</div>
              </div>
            </div>
            <div className="io-card">
              <div className="io-icon-wrapper">
                <img
                  src="https://uploads-ssl.webflow.com/60faa77e21b22054e04713b8/60fc2b77d806aaf245f3736d_icons8-txt-52.png"
                  loading="lazy"
                  width={23}
                  alt=""
                />
              </div>
              <div className="io-files-wrapper">
                <div className="io-files-text">*.bam *.bai</div>
              </div>
              <div className="io-type _2">
                <div className="text-block-6 _2">Sorted Maping</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* --- Alignment Modal --- */}
      <Modal show={showAlignmentModal} onHide={handleCloseAlignmentModal}
      // backdrop="static"
      keyboard={true}
      // fullscreen={true}
      centered
      // size="lg"
      dialogClassName="div-block-12"
      // contentClassName="div-block-12"
      >
      {/* <Modal.Body> */}
        {/* <div className="div-block-12" style={{
          width: "100%"
        }}> */}
          <div className="div-block-13">
            <div className="div-block-25">
              <img
                src="https://uploads-ssl.webflow.com/60faa77e21b22054e04713b8/60fc3a2f21621b84f7932381_icons8-back-96.png"
                loading="lazy"
                width={16}
                alt=""
              />
              <div className="text-block-3">Back</div>
            </div>
            <div className="text-block-2">Alignment</div>
            <div />
          </div>
          <div className="div-block-27">
            <div className="div-block-39">Star</div>
            <div className="div-block-39">Bowtie2</div>
            <div className="div-block-39">Burrows-Wheeler Aligner (BWA)</div>
            <div className="div-block-39">HiSat2</div>
            <div className="div-block-39">Tophat</div>
          </div>
          <div className="div-block-29">
            <div className="div-block-30">
              <div className="div-block-43">
                <div className="text-block-18">Star:</div>
                <div className="btn-2">
                  <div className="btn-2-text">Version 2.0</div>
                  <img
                    src="https://uploads-ssl.webflow.com/60faa77e21b22054e04713b8/60fc2f152b2dc0e3c9a69611_icons8-chevron-down-90.png"
                    loading="lazy"
                    width={22}
                    alt=""
                    className="image"
                  />
                </div>
              </div>
              <div className="text-block-17">Application:</div>
              <p className="text-block-8">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                Suspendisse varius enim in eros elementum tristique. Duis
                cursus, mi quis viverra ornare, eros dolor interdum nulla, ut
                commodo diam libero vitae erat. Aenean faucibus nibh et justo
                cursus id rutrum lorem imperdiet. Nunc ut sem vitae risus
                tristique posuere.
              </p>
              <div className="text-block-17">Use Case:</div>
              <p className="text-block-8">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                Suspendisse varius enim in eros elementum tristique. Duis
                cursus, mi quis viverra ornare, eros dolor interdum nulla, ut
                commodo diam libero vitae erat. Aenean faucibus nibh et justo
                cursus id rutrum lorem imperdiet. Nunc ut sem vitae risus
                tristique posuere.
              </p>
              <div className="text-block-17">Input Requirments</div>
              <p className="text-block-8">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                Suspendisse varius enim in eros elementum tristique. Duis
                cursus, mi quis viverra ornare, eros dolor interdum nulla, ut
                commodo diam libero vitae erat. Aenean faucibus nibh et justo
                cursus id rutrum lorem imperdiet. Nunc ut sem vitae risus
                tristique posuere.
              </p>
            </div>
            <div className="div-block-31">
              <div className="text-block-17 center">App Information</div>
              <p className="text-block-8 center">
                <a href="#" className="link">
                  Homepage
                </a>
                <br />
                <br />
                <a href="#" className="link">
                  Publication
                  <br />
                </a>
                <br />
                <a href="#" className="link">
                  Source Code
                </a>
                <br />
                <br />
                <a href="#" className="link">
                  License
                </a>
              </p>
            </div>
          </div>
          <div className="div-block-26">
            <div className="div-block-40">
              <div className="div-block-41">Inputs</div>
              <div className="div-block-41">Settings</div>
              <div className="div-block-41">Outputs</div>
            </div>
            <div className="div-block-42" />
          </div>
        {/* </div>/ */}
        {/* </Modal.Body> */}
      </Modal>
    </>
  );
};

export default Analysis;
